import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";
import {withLocalize} from "react-localize-redux";

import { Translate } from "react-localize-redux";
import italianProfileTranslations from "../../translations/profile/it.profile.json";
import englishProfileTranslations from "../../translations/profile/en.profile.json";

class UserHeader extends React.Component {
  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianProfileTranslations, "it");
    this.props.addTranslationForLanguage(englishProfileTranslations, "en");
  }

  render() {
    return (
      <>
          <span className="mask bg-gradient-default opacity-8" />
          <Container className="d-flex align-items-center header pb-8 pt-5 pt-lg-8 d-flex align-items-center" fluid>
            <Row>
              <Col lg="7" md="10">
                <h1 className="display-2 text-white">
                  <Translate id="profile.user.header" />
                </h1>
                <p className="text-white mt-0 mb-3">
                </p>
              </Col>
            </Row>
          </Container>
      </>
    );
  }
}

export default withLocalize(UserHeader);
